import axios from 'axios';
import {
  FETCH_MARKET_INFO_REQUEST,
  FETCH_MARKET_INFO_SUCCESS,
  FETCH_MARKET_INFO_FAILURE,
} from 'Store/constants';

export const fetchMarketInfo = (marketType, marketSubType) => async dispatch => {
  dispatch({
    type: FETCH_MARKET_INFO_REQUEST,
  });

  try {
    const res = await axios.get(`/cms/sbsContents/marketType/info/${marketType}/${marketSubType}`);

    dispatch({
      type: FETCH_MARKET_INFO_SUCCESS,
      payload: res.data
    });

    return res.data;
  } catch (error) {
    dispatch({
      type: FETCH_MARKET_INFO_FAILURE,
      payload: error.response && error.response.data,
    });

    throw error;
  }
};